/* tslint:disable */
/* eslint-disable */
/**
 * Poolside API
 * Poolside API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AmlStatus,
    AmlStatusFromJSON,
    AmlStatusFromJSONTyped,
    AmlStatusToJSON,
} from './';

/**
 * data required to create a company or fund record
 * @export
 * @interface CompanyData
 */
export interface CompanyData {
    /**
     * 
     * @type {string}
     * @memberof CompanyData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyData
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyData
     */
    registryCode?: string;
    /**
     * 
     * @type {AmlStatus}
     * @memberof CompanyData
     */
    amlStatus?: AmlStatus;
}

export function CompanyDataFromJSON(json: any): CompanyData {
    return CompanyDataFromJSONTyped(json, false);
}

export function CompanyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'registryCode': !exists(json, 'registryCode') ? undefined : json['registryCode'],
        'amlStatus': !exists(json, 'amlStatus') ? undefined : AmlStatusFromJSON(json['amlStatus']),
    };
}

export function CompanyDataToJSON(value?: CompanyData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'address': value.address,
        'registryCode': value.registryCode,
        'amlStatus': AmlStatusToJSON(value.amlStatus),
    };
}

